
























import { computed, defineComponent } from '@vue/composition-api'
import Const from '@/util/Const'
import AtomInputSelectObject from '@/components/atoms/input/AtomInputSelectObject.vue'
import FormErrorMessageParts from '@/components/common/form/FormErrorMessageParts.vue'
import { Multilingual } from '@/store/stores/collectionModule/documents/GeneralTypes'

type countryType = {
  name: Multilingual
  id: string
}
export type DataType = {
  countryData: Array<countryType>
}

/**
 * フィールドセット お住まいの国入力 バーツ
 */
export default defineComponent({
  name: 'FieldsetCountryParts',
  components: {
    AtomInputSelectObject,
    FormErrorMessageParts,
  },
  props: {
    /**
     * 入力データ
     */
    value: {
      type: String,
      default: '',
    },
    /**
     * 必須フラグ
     */
    required: {
      type: Boolean,
      default: false,
    },
    /**
     * エラーフラグ
     */
    showError: {
      type: Boolean,
      default: false,
    },
    /**
     * エラーメッセージ
     */
    errorMessage: {
      type: String,
      default: '',
    },
  },
  data(): DataType {
    return {
      /**
       * お住まいの国一覧
       */
      countryData: Const.USER_COUNTRY_LIST,
    }
  },
  setup(props, context) {
    /**
     * country
     * @param {string} val 国
     */
    const country = computed({
      get: () => props.value,
      set: (val: string) => context.emit('input', val),
    })
    return {
      country,
    }
  },
  methods: {
    /**
     * 選択が変更されたことを通知する
     */
    change() {
      /**
       * 選択が変更されたことを通知する
       * @event change
       * @type {Object}
       */
      this.$emit('change')
    },
    /**
     * Enter Push
     */
    emitEnter() {
      /**
       * Enterボタン押下を通知する
       * @event enter
       * @type {Object}
       */
      this.$emit('enter')
    },
  },
})
